export var xhrUploader = function xhrUploader(_ref) {
  var endpoint = _ref.endpoint,
      _ref$fileKeyName = _ref.fileKeyName,
      fileKeyName = _ref$fileKeyName === void 0 ? "file" : _ref$fileKeyName,
      _ref$method = _ref.method,
      method = _ref$method === void 0 ? "POST" : _ref$method,
      _ref$responseKey = _ref.responseKey,
      responseKey = _ref$responseKey === void 0 ? "url" : _ref$responseKey,
      responseFunction = _ref.responseFunction,
      settingsFunction = _ref.settingsFunction;
  return function (file, updateProgress) {
    return new Promise(function (resolve, reject) {
      var formData = new FormData();
      formData.append(fileKeyName, file);
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open(method, endpoint, true);
      if (typeof settingsFunction === "function") settingsFunction(xmlHttp);
      xmlHttp.addEventListener("progress", function (event) {
        if (typeof updateProgress === "function") updateProgress(event.loaded / event.total);
      });
      xmlHttp.addEventListener("load", function () {
        var responseText = xmlHttp.responseText;
        if (typeof responseFunction === "function") return resolve(responseFunction(responseText));
        var json = JSON.parse(responseText);
        return resolve(json[responseKey]);
      });
      xmlHttp.addEventListener("error", function () {
        return reject("errors.response_not_ok");
      });
      xmlHttp.addEventListener("abort", function () {
        return reject("errors.upload_aborted");
      });
      xmlHttp.send(formData);
    });
  };
};
export var fetchUploader = function fetchUploader(_ref2) {
  var endpoint = _ref2.endpoint,
      settingsFunction = _ref2.settingsFunction,
      _ref2$method = _ref2.method,
      method = _ref2$method === void 0 ? "POST" : _ref2$method,
      _ref2$fileKeyName = _ref2.fileKeyName,
      fileKeyName = _ref2$fileKeyName === void 0 ? "file" : _ref2$fileKeyName,
      _ref2$responseKey = _ref2.responseKey,
      responseKey = _ref2$responseKey === void 0 ? "url" : _ref2$responseKey,
      responseFunction = _ref2.responseFunction;
  return function (file) {
    return new Promise(function (resolve, reject) {
      var formData = new FormData();
      formData.append(fileKeyName, file);
      window.fetch(endpoint, settingsFunction ? settingsFunction(file) : {
        method: method,
        body: formData
      }).then(function (response) {
        if (!response.ok) throw new Error("errors.response_not_ok");
        return response.json();
      }).then(function (json) {
        if (typeof responseFunction === "function") return resolve(responseFunction(json));
        return resolve(json[responseKey]);
      }).catch(function () {
        return reject("errors.response_not_ok");
      });
    });
  };
};